// actions/staffActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file
// (including staff bulk-upload) would silently 401 on mobile/desktop.
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllStaff =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_STAFF_REQUEST" });
      const { data } = await api.get("/staff", { params });
      dispatch({ type: "ALL_STAFF_SUCCESS", payload: data.staff });
    } catch (err) {
      dispatch({
        type: "ALL_STAFF_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

export const createStaff = (staffData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_STAFF_REQUEST" });
    const { data } = await api.post("/staff", staffData);
    dispatch({ type: "CREATE_STAFF_SUCCESS", payload: data.staff });
  } catch (err) {
    dispatch({
      type: "CREATE_STAFF_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// actions/staffActions.js కింద ఈ కోడ్ యాడ్ చెయ్
export const bulkUploadStaff = (staffData) => async (dispatch) => {
  try {
    dispatch({ type: "BULK_UPLOAD_REQUEST" });
    // axios api instance ని యూజ్ చేసి కరెక్ట్ బ్యాకెండ్ కి పంపిస్తున్నాం
    const { data } = await api.post("/staff/bulk-upload", { staff: staffData });
    dispatch({ type: "BULK_UPLOAD_SUCCESS", payload: data });
    return data;
  } catch (err) {
    dispatch({
      type: "BULK_UPLOAD_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};
